import MaterialSinglePropertyAssigner from "../../../output/assets/materials/material-single-property-assigner.js";

class ThreeMaterialEnvLightAssigner extends MaterialSinglePropertyAssigner {
    constructor() {
        super();
    }

    setProperty(material, envLight) {
        if (Boolean(material.envMap) !== Boolean(envLight)) {
            material.needsUpdate = true;
        }

        material.envMap = envLight || null;
    }
}

export default ThreeMaterialEnvLightAssigner;
